import { render } from "./AddLead.vue?vue&type=template&id=e73674d8"
import script from "./AddLead.vue?vue&type=script&lang=js"
export * from "./AddLead.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__